<template>
  <Layout>
    <TableView slot="content" @action="action" @nextList="nextList" :list="list" 
      :check-actions="[{text: 'OFAC 확인', variant: 'success'}, {text: '확인취소', variant: 'danger'}]"
      :columns="columns" :data="sel" :filter="filter" :server-total="total" minWidth="1015px">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search" />
        <!-- 일반적으로는 oninput(모든 키입력마다 발생) 에서 업데이트되는 v-model 을 쓰지만 searchKeyword 를 watch 하여 api 연동하므로 입력폼에서 포커스가 나올때 변경이 있으면 발생되는 onchange 이벤트에서만 업데이트 되도록 구현했습니다.  -->
        <input @change="searchKeyword = $event.target.value" class="form-control form-control-solid w-300px ps-11"
          :placeholder="$t('조직, 사용자명, 아이디, 이메일, 연락처')" :title="$t('조직, 사용자명, 아이디, 이메일, 연락처')">
      </div>      
    </TableView>
    <ModalForm id="view" :title="$t('사용자')" :data="sel" :spec="columns"/>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
const required = true;

export default {
  components: { Layout, TableView, ModalForm },
  data: () => ({
    sel: {},
    list: [],
    total: 0,
    searchKeyword: '',
    ifRed:'',
    columns: [
      { key: 'ofacStatusNm', label: '상태', form: 1, renderer: item => `<b class="badge badge-light-${item.ofacStatusClass}">${item.ofacStatusNm}</b>`, style: { textAlign: 'center' } },
      { key: 'custName', label : '조직', form: 1.2, style: { textAlign: 'center' } },
      { label: '사용자', renderer: item => `${item.userNm} (${item.userIdText})`, style: { textAlign: 'center' } },
      { key: 'userNm', label: '사용자', form: 2, hide: ['td'], style: { textAlign: 'center' } },
      { key: 'grpNm', label: '그룹', form: 4, style: { textAlign: 'center', minWidth:'90px' } },
      { key: 'userNmEn', label: '사용자영문명', form: 5, required, style: { textAlign: 'center' } },
      { key: 'email', type: 'email', label: '이메일', form: 6, required, style: { textAlign: 'center' } },
      { key: 'phone', label: '연락처', form: 7, required, type: 'tel', style: { textAlign: 'center' } },
      { key: 'effectDt', label: '발효일', form: 8, required, type: 'date', style: { textAlign: 'center', minWidth:'95px' }, sendMaper: v => v.replace(/-/g, '') },
      { label: '생성자', renderer: item => `${item.modUserNm} (${item.modUserId})`, style: { textAlign: 'center' } },
      { key: 'modDt', label: '생성일', type: 'datetime-local', style: { textAlign: 'center', minWidth:'95px' } },
    ],
    filter: {
      ofacStatusNm: [],
      // grpNm: [],
    },
    detail: { effectDt: ['', ''], pwdErrCnt: 0 },
  }),
  created() { this.getList() },
  mounted() { },  
  beforeDestroy() { },
  computed: {},
  watch: { searchKeyword() { this.getList() } },
  methods: {
    async action({ action, item }) {
      let api, form = {};
      this.sel = item;

      if (action == 'view') {
        const unmaskKey = await this.$unmask('USER_INFO_OFAC');
        const selUser = await this.$api('adm/ofac/selectUser', { unmaskKey, masking: false, userId : this.sel.userId });
        for (const key in selUser.data) { 
          this.sel[key] = selUser.data[key];
        }
        return this.$bvModal.show(action);
      }

      if (action.indexOf('일괄 ') == 0) {
        form.memberId = this.sel.memberId;
        form.custId = this.sel.custId;
        window.tmp = v => form.statusReason = v;
        
        if (!(await this.$alert(`${this.$t('해당 항목을 $ 처리하시겠습니까?', [action])}<div class="alert_list"><ul><li>${this.sel.map(i => i.userNm).join('</li><li>')}</li></ul></div>
        <textarea style="width:100%" onchange="tmp(this.value)" placeholder="${this.$t('비고')}"></textarea>`, { okVariant: action.indexOf('취소') > 0 ? 'danger' : 'success', okTitle: action.slice(3), title: action, confirm: true }))) return;
        api = action == '일괄 OFAC 확인' ? 'approveOfac' : 'cancelOfac';
        const success = [], fail = [];
        for (const { custId, memberId, userNm } of this.sel) {
          form.custId = custId;
          form.memberId = memberId;
          if ((await this.$api('adm/ofac/' + api, form)).success) success.push(userNm);
          else fail.push(userNm);
        }
        await this.$alert(this.$t('[$] 을 $ 했습니다.', [success.join(), action]) + (fail.length ? '<br>' + this.$t('실패한 항목: [$]', [fail.join()]) : ''));
        if (!success.length) return;
        this.getList();
        return
      }
    },
    /** 목록 데이터 수신 */
    async getList(firstIndex = 1) {
      const res = await this.$api('adm/ofac/selectOfacMemberList', { firstIndex, searchKeyword: this.searchKeyword });
      this.list = firstIndex == 1 ? res.list : this.list.concat(res.list);      
      this.total = res.parameter.total;
      // console.dir(this)
      Object.keys(this.filter).forEach(k => this.filter[k] = [...new Set(this.list.map(r => r[k] || ''))]);
    },
    nextList() { if (this.total > this.list.length) this.getList(this.list.length + 1); },
  },
}
</script>